import { HorizontalContainer, VerticalContainer } from '@/components';
import type { PfaProgressCard } from '@/features/profile/model/types';
import { format, R } from '@/features/profile/resources/ProfileResources.resx';
import { Utils } from '@/shared/Utils';

type PfaProgressCardViewProps = {
    progressCard: PfaProgressCard;
};

export const PfaProgressCardView = ({
    progressCard,
}: PfaProgressCardViewProps) => (
    <VerticalContainer
        spacing="lg"
        className="w-full basis-80 rounded-2xl border border-(--color-border-muted) p-6"
    >
        <HorizontalContainer className="justify-between">
            {progressCard.IconFilename && (
                <img
                    width="40"
                    height="40"
                    src={`/images/icons/${progressCard.IconFilename}`}
                    alt=""
                />
            )}
            <VerticalContainer
                spacing="none"
                className="ml-auto text-right text-sm text-(--color-text-secondary)"
            >
                {progressCard.ExpiryDate && (
                    <span>
                        {R.Expires}{' '}
                        {Utils.formatLongDate(progressCard.ExpiryDate)}
                    </span>
                )}
                <span>
                    {format(
                        R.ConsultationsUsed,
                        progressCard.CouponRedemptions?.toString() ?? '',
                        progressCard.ConsultationsAllowed?.toString() ?? '',
                    )}
                </span>
            </VerticalContainer>
        </HorizontalContainer>

        <h3 className="text-2xl leading-tight font-bold text-(--color-text-heading)">
            {progressCard.CaregiverName}
        </h3>

        <VerticalContainer spacing="sm" className="text-lg">
            <p>
                {R.IssuedTo}: {progressCard.PatientFullName}
            </p>
            {progressCard.InjuryDescription && (
                <p>
                    {R.InjuryDescription}: {progressCard.InjuryDescription}
                </p>
            )}
        </VerticalContainer>
    </VerticalContainer>
);
